export default "__VITE_ASSET__CmxUyucv__"